<div *ngIf="subscription" class="pricing a-fx-col a-fx-gap-24 a-fx-between-start" [class.pricing-new]="newPlan">
    <div class="a-fx-col a-fx-gap-48 a-fx-none" *ngIf="currency$ | async as currency">
        <div class="a-fx-none a-fx-col a-fx-gap-32">
            <div class="h3">
                {{ 'settings.customer-subscription.pricing-details' | translate }}
            </div>

            <p>
                <ng-container *ngIf="newPlan">
                    <span [innerHTML]="'settings.customer-subscription.pricing-details-message-new' | translate"></span>
                    &ngsp;
                    <span
                        class="a-color-light-blue a-text-underline-hover"
                        adsptHeap="subscription-plan-example"
                        (click)="onShowExample()"
                        >{{ 'settings.customer-subscription.pricing-details-message-example' | translate }}
                    </span>
                </ng-container>

                <span
                    *ngIf="!newPlan"
                    [innerHTML]="'settings.customer-subscription.pricing-details-message-existing' | translate"
                ></span>
            </p>
        </div>

        <div
            *ngIf="subscription.pricingDetails?.volumeFlatFeeOrPercentage as plans"
            class="a-fx"
            adsptEqualSizeContainer
        >
            <div
                *ngFor="let plan of plans"
                class="a-fx-col a-fx-gap-24 a-fx-flex pricing-plan"
                [ngSwitch]="plan.volumeType"
            >
                <div class="a-fx-col a-fx-gap-24 a-fx-none" adsptEqualSize="height">
                    <div class="h4">
                        <ng-container *ngIf="plan.platforms?.length > 1; else singlePlatformTmpl">
                            {{ 'settings.customer-subscription.platform-group' | translate }}
                        </ng-container>

                        <ng-template #singlePlatformTmpl>
                            {{ 'settings.customer-subscription.platform' | translate }}
                        </ng-template>
                    </div>

                    <div class="a-fx a-fx-gap-8 a-fx-start-center">
                        <ng-container *ngFor="let platform of plan.platforms">
                            <img class="pricing-platform" [src]="PlatformImages[platform]" [alt]="platform" />
                        </ng-container>
                    </div>

                    <div class="a-fx-col a-fx-gap-16">
                        <div
                            *ngSwitchCase="BillingVolumeType.AttributedSales"
                            class="caption-1 a-color-secondary"
                            [innerHTML]="
                                'settings.customer-subscription.less-than-attributed'
                                    | translate
                                        : {
                                              threshold:
                                                  plan.threshold
                                                  | microsToNumber
                                                  | currency: currency : 'symbol' : '1.0-2',
                                          }
                            "
                        ></div>

                        <div
                            *ngSwitchCase="BillingVolumeType.AdSpend"
                            class="caption-1 a-color-secondary"
                            [innerHTML]="
                                'settings.customer-subscription.less-than-ad-spend'
                                    | translate
                                        : {
                                              threshold:
                                                  plan.threshold
                                                  | microsToNumber
                                                  | currency: currency : 'symbol' : '1.0-2',
                                          }
                            "
                        ></div>

                        <div class="a-fx-col">
                            <div class="h2">
                                {{ plan.flatFee | microsToNumber | currency: currency : 'symbol' }}
                            </div>

                            <div class="caption-1">
                                {{ 'settings.customer-subscription.monthly-unlimited-accounts' | translate }}
                            </div>
                        </div>
                    </div>
                </div>

                <nz-divider></nz-divider>

                <div class="a-fx-col a-fx-gap-16 a-fx-none">
                    <div
                        class="caption-1"
                        [innerHTML]="
                            'settings.customer-subscription.above-threshold'
                                | translate
                                    : {
                                          threshold:
                                              plan.threshold | microsToNumber | currency: currency : 'symbol' : '1.0-2',
                                      }
                        "
                    ></div>

                    <div class="a-fx-col">
                        <div class="h2">
                            {{ plan.percentage / 100 | percent: '1.2-2' }}
                        </div>

                        <div *ngSwitchCase="BillingVolumeType.AttributedSales" class="caption-1">
                            {{ 'settings.customer-subscription.aggregated-attributed-unlimited' | translate }}
                        </div>

                        <div *ngSwitchCase="BillingVolumeType.AdSpend" class="caption-1">
                            {{ 'settings.customer-subscription.aggregated-ad-spend-unlimited' | translate }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <p *ngIf="'settings.customer-subscription.find-full-pricing' | translate as fullPricing" class="a-fx-none">
        {{ fullPricing | translatePart: 0 }}
        <a href="https://adspert.net/pricing" target="_blank" adsptHeap="subscription-plan-link">{{
            fullPricing | translatePart: 1
        }}</a
        >{{ fullPricing | translatePart: 2 }}
    </p>
</div>

<ng-container
    adsptHeap="subscription-details-close"
    [useParent]="true"
    [debounceResolve]="true"
    [elementPath]="{ parent: '.ant-modal-content', child: '.ant-modal-footer .ant-btn-primary' }"
/>
<ng-container
    adsptHeap="subscription-details-examples"
    [useParent]="true"
    [debounceResolve]="true"
    [elementPath]="{ parent: '.ant-modal-content', child: '.ant-modal-footer .ant-btn' }"
/>
